module.exports = __webpack_public_path__ + "static/img/level45.5b79a30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/crown-crunch/level45.png
// module id = 8bKL
// module chunks = 0